import { Dayjs } from "dayjs";
import ProcessorApiType from "../Components/Enums/ProcessorApiType";

export interface GCInfoModel {
    // Gift Card Information
    giftCardNumber: string;
    giftCardPin: string;
    issuerName: string;
    brandId: string;
    brandName: string;
    brandApiType: string;
    cashOutAmount: string;
    cardPurchasedDate: Dayjs | null;
    beginningCardBalance: string;
}

export interface GCInfoErrors {
    giftCardNumberError: boolean;
    giftCardPinError: boolean;
    issuerNameError: boolean;
    brandNameError: boolean;
    cashOutAmountError: boolean;
    cardPurchasedDateError: boolean;
    beginningCardBalanceError: boolean;
    errors: string[];
}

export const validateGCInfo = (model: GCInfoModel): GCInfoErrors => {
    let errors : GCInfoErrors = {
        giftCardNumberError: false,
        giftCardPinError: false,
        issuerNameError: false,
        brandNameError: false,
        cashOutAmountError: false,
        cardPurchasedDateError: false,
        beginningCardBalanceError: false,
        errors: []
    }
    // Validate Gift Card Number
    if (model.giftCardNumber === '') {
        errors.giftCardNumberError = true;
        errors.errors.push('Gift Card Number is required');
    }

    // Validate Gift Card Pin
    if (model.giftCardPin === '') {
        errors.giftCardPinError = true;
        errors.errors.push('Gift Card Pin is required');
    }

    // Validate Issuer Name
    if (model.issuerName === '') {
        errors.issuerNameError = true;
        errors.errors.push('Issuer Name is required');
    } 

    // Validate Brand Name
    if (model.brandName === '') {
        errors.brandNameError = true;
        errors.errors.push('Brand Name is required');
    }

    // Validate Cash Out Amount
    if (parseFloat(model.cashOutAmount) === 0) {
        errors.cashOutAmountError = true;
        errors.errors.push('Remaining Balance is required');
    }

    // Validate Card Purchase Date
    if (model.brandApiType != undefined &&
        model.brandApiType === ProcessorApiType.Manual &&
        model.cardPurchasedDate === null) {
        errors.cardPurchasedDateError = true;
        errors.errors.push('Card Purchase Date is required');
    }

    // Validate Beginning Card Balance
    if (model.brandApiType != undefined &&
        model.brandApiType === ProcessorApiType.Manual &&
        parseFloat(model.beginningCardBalance) === 0) {
        errors.beginningCardBalanceError = true;
        errors.errors.push('Beginning Card Balance is required');
    }
    return errors;
}

export const defaultGCInfoModel = (issuerName: string) : GCInfoModel => {
    return {
        // Gift Card Information
        giftCardNumber: '',
        giftCardPin: '',
        issuerName: issuerName,
        brandId: '',
        brandName: '',
        brandApiType: '',
        cashOutAmount: "0.00",
        cardPurchasedDate: null,
        beginningCardBalance: "0.00",
    }
}
